import React, { SyntheticEvent } from "react";
import { Button, Modal } from "rsuite";
import { RemindOutline } from "@rsuite/icons";

interface AlertModalInterface {
  handleClose: any;
  open: boolean;
  displayText?: null | string;
  modalTitle?: null | string;
  okButton?: null | boolean;
  cancelButton?: null | boolean;
}

export function AlertModal({
  handleClose,
  open,
  displayText = "Are you sure to perform this activity?",
  okButton = true,
  cancelButton = true,
  modalTitle = "Please confirm",
}: AlertModalInterface) {
  return (
    <Modal
      backdrop="static"
      role="alertdialog"
      open={open}
      onClose={handleClose}
      size="xs"
    >
      <Modal.Header>
        <Modal.Title style={{ textAlign: "center" }}>
          <RemindOutline
            style={{
              color: "#ffb300",
              fontSize: 20,
              marginRight: 5,
            }}
          />
          {modalTitle} 
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ marginTop: "7px", paddingBottom: "10px" }}>
        {displayText}
      </Modal.Body>
      <Modal.Footer style={{ textAlign: "center" }}>
        {okButton && (
          <Button onClick={() => handleClose(true)} appearance="primary">
            Ok
          </Button>
        )}
        {cancelButton && (
          <Button onClick={() => handleClose(false)} appearance="subtle">
            Cancel
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
